<template>
  <div class="analysis">
    <div class="analysisOverview">
      <div class="analysisOverview-title">
        <h3>测算概览</h3>
      </div>
      <div class="analysisOverview-main">
        <div class="analysisOverview-main-top">
          <ul>
            <li>
              <p>
                • 客户当前有{{ textObj.childCountResult }}个子女需要进行教育规划， 距离{{ textObj.childCountResult > 1 ? "他们" : textObj.childRelation === "4" ? "他" : "她" }}毕业最长还有<span>{{ textObj.maxYears }}</span>年。 在未来的学习生涯中，将会产生学费<span>{{ textObj.eduAndLiveExpenseMap.sumEduExpense | addMoneyFilter }}元</span>， 生活费<span>{{ textObj.eduAndLiveExpenseMap.sumLiveExpense | addMoneyFilter }}元</span>。
              </p>
            </li>
            <li>
              <p>
                • 客户当前已为子女准备了教育储备金<span>{{ textObj.getReserveInfo.currentMoney | addMoneyFilter }}元</span>， 计划未来每月储蓄<span>{{ textObj.getReserveInfo.monthMoney | addMoneyFilter }}元</span>，期望教育储备金每年能产生<span> {{ textObj.getReserveInfo.expectedRevenue }}%</span>的收益。
              </p>
            </li>
            <li>
              <p>
                • 客户的风险等级为<span>{{ textObj.riskLevelInfo.riskLevel }}</span>。
              </p>
            </li>
          </ul>
        </div>
        <div class="analysisOverview-main-bottom">
          <ul>
            <li>
              <strong>1</strong>
              <p v-if="textObj.getMeasureReserve.irr === '无法达成规划'">
                根据客户已存教育储备金{{ textObj.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ textObj.getReserveInfo.monthMoney | addMoneyFilter }}元，则
                <span class="red">{{ textObj.getMeasureReserve.irr }}</span>
              </p>
              <p v-else-if="textObj.getMeasureReserve.irr > 0">
                根据客户已存教育储备金{{ textObj.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ textObj.getReserveInfo.monthMoney | addMoneyFilter }}元， 则至少需要达到年化<span class="red">{{ textObj.getMeasureReserve.irr.toFixed(2) }}%</span>的投资收益， 才能满足客户的规划需求。
              </p>
              <p v-else>根据客户已存教育储备金{{ textObj.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ textObj.getReserveInfo.monthMoney | addMoneyFilter }}元，<span class="red"> 则目前客户储备情况已能满足子女教育需求。</span></p>
            </li>
            <li>
              <strong>2</strong>
              <p>
                根据客户每月储蓄{{ textObj.getReserveInfo.monthMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ textObj.getReserveInfo.expectedRevenue }}%， 则当前的子女教育储备金<span class="red">
                  <span v-if="textObj.getMeasureReserve.reserveGap === 0">存在资金缺口</span>
                  <span v-else>资金富余</span>
                  {{ textObj.getMeasureReserve.reserveBreach | addMoneyFilter }}元 </span>。
              </p>
            </li>
            <li>
              <strong>3</strong>
              <p>
                根据客户已存教育储备金{{ textObj.getReserveInfo.currentMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ textObj.getReserveInfo.expectedRevenue }}%，
                <span v-if="textObj.getMeasureReserve.monthGap !== 2">
                  则每月投入的子女教育储备金
                  <span class="red">
                    <span v-if="textObj.getMeasureReserve.monthGap === 0">存在资金缺口</span>
                    <span v-else>资金富余</span>
                    {{ textObj.getMeasureReserve.monthBreach | addMoneyFilter }}元
                  </span></span><span v-else
                      class="red"> {{ textObj.getMeasureReserve.monthBreach }}</span>。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="analysisTabs">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="现金流分析"
                     name="first">
          <div class="analysisTabs-first">
            <h3>现金流分析图</h3>
            <highCharts :id="id"
                        :option="option"
                        v-if="highChartsShow"></highCharts>
            <el-table v-if="activeName === 'first'"
                      :header-cell-style="{ background: '#F5F7FA' }"
                      class="tb-edit"
                      border
                      :data="tableData"
                      height="500"
                      style="width: 100%;">
              <el-table-column fixed
                               prop="year"
                               label="年份"
                               width="80"> </el-table-column>
              <template v-for="(col, i) in cols">
                            <el-table-column :key="i"
                                 :label="col.name"
                                 header-align='center'>
                                 <el-table-column
                                 label="生活费现金流"
                                 :prop="col.propTwo"> </el-table-column>
                                 <el-table-column
                                 label="学费现金流"
                                 :prop="col.propOne"> </el-table-column>
                                 </el-table-column>
              </template>
              <el-table-column align="right"
                               label="教育储备金现金流">
                <template slot-scope="scope">
                  {{ scope.row.reserve | addMoneyFilter }}
                </template>
              </el-table-column>
              <el-table-column align="right"
                               label="总资产">
                <template slot-scope="scope">
                  {{ scope.row.total | addMoneyFilter }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="可行性分析"
                     name="second">
          <div class="analysisTabs-second"
               v-if="meterStatus === '1'">
            <div class="analysisTabs-second-left">
              <p>
                根据测算，基于客户提供的数据在不进行干预下实现整体规划的可能性为<span>{{ meterDataMsg }}%</span>
              </p>
              <v-chart :options="meterData"
                       v-if="meterDataShow" style="width:550px;" ></v-chart>
            </div>
            <div class="analysisTabs-second-right">
              <v-chart :options="monteCarloData"
                       v-if="monteCarloDataShow" style="width:850px;"></v-chart>
              <p>本次方案的可行性分析与实现可能性是系统基于蒙特卡洛模拟这一分析方法计算得来。 蒙特卡洛模拟是一种数据统计方法，我们会通过多达100000次的模拟测试， 在每一次模拟中随机生成客户在未来规划生涯中每一年可能的投资收益， 来模拟客户可能的资产变化情况。通过观察统计在这100000次模拟中客户资产可以完全覆盖子女教育消费支出的情景个数， 来计算得出客户实现整体方案规划的实现可能性。</p>
              <p>需要注意，本次模拟中涉及到的投资收益是我们依据客户当前的风险等级，并通过分析统计市场上同类型客户投资收益情况综合所得，力求能最大程度的还原真实的投资环境所进行的模拟测试。其模拟结果并不代表真实投资收益。通过计算得出的方案实现可能性结果仅供此次方案测算参考，并不代表未来实际情况。</p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'analysis',
  data() {
    return {
      // tabs参数
      activeName: '',
      // 现金流分析图参数
      id: 'test',
      option: {},
      highChartsShow: false,
      // 现金流分析表格参数
      tableData: [],
      cols: [],
      // 可行性分析仪表盘数据
      meterData: {},
      meterDataMsg: '',
      meterDataShow: false,
      // 蒙特卡洛分析图数据
      monteCarloData: {},
      monteCarloDataShow: false,
      // 判断是否需要测算可行性分析      0是从未测算，1是已测算有结果，2是发生发边重新测试
      meterStatus: 0,
      // 页面红色字段
      textObj: {
        childCountResult: '',
        getReserveInfo: {
          maxYears: '',
          currentMoney: '',
          monthMoney: '',
          expectedRevenue: '',
        },
        getMeasureReserve: {
          irr: '',
          reserveBreach: '',
          monthBreach: '',
        },
        eduAndLiveExpenseMap: {
          sumEduExpense: '',
          sumLiveExpense: '',
        },
        riskLevelInfo: {
          riskLevel: '',
        },
      },
      //  从session取客户信息
      cust: {},
    };
  },
  watch: {},
  created() {
    this.cust = JSON.parse(sessionStorage.getItem('custInfo'));
    // 加载现金流分析图
    const parames = {
      data: {
        cis: this.cust.cis,
        uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
      },
    };
    // 现金流分析图
    this.getEduAnalyzeChartFn(parames);
    // 现金流表格
    this.getEduAnalyzeTableFn(parames);
    // 蒙特卡洛分析图
    // 初始化传1过去 根据接口返回值赋值给这个变量，在传到后台
    this.getEduAnalyzeFeasibilityStatusFn('1');
    // 测算概览 红色字段
    const parame = {
      data: {
        cis: this.cust.cis,
        uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
      },
    };
    // 查询页面红色字段
    this.getMeasurePreviewFn(parame);
  },
  methods: {
    getEduAnalyzeChartFn(parames) {
      this.$_post(this.$API.getEduAnalyzeChart, parames)
        .then((res) => {
          const chartsData = res.data;
          const obj = { name: '总资产', type: 'line', data: res.data.cashTotals };
          chartsData.listEduPlanCharts.push(obj);
          this.cashFlowImgFn(chartsData);
        })
        .catch(error => console.log(error));
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    cashFlowImgFn(chartsData) {
      const arr = [];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < chartsData.listEduPlanCharts.length; i++) {
        const aa = { name: '', data: [] };
        aa.name = chartsData.listEduPlanCharts[i].name;
        aa.data = chartsData.listEduPlanCharts[i].data;
        if (chartsData.listEduPlanCharts[i].name === '教育储备金') {
          aa.color = '#35C98C';
        } else if (chartsData.listEduPlanCharts[i].name === '学费现金流') {
          aa.color = '#4BA0FF';
        } else if (chartsData.listEduPlanCharts[i].name === '生活费现金流') {
          aa.color = '#FA7575';
        } else if (chartsData.listEduPlanCharts[i].name === '总资产') {
          aa.color = '#909399';
          aa.type = 'line';
        }
        arr.push(aa);
      }
      console.log(arr, '现金流图数据');
      this.option = {
        credits: {
          enabled: false, // 不显示LOGO
        },
        chart: {
          type: 'column',
        },
        title: {
          text: '',
        },
        tooltip: {
          text: '',
        },
        // 保留两位小数点的办法
        // eslint-disable-next-line no-dupe-keys
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          // eslint-disable-next-line no-useless-concat
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        legend: {
          align: 'left',
          verticalAlign: 'top',
        },
        xAxis: {
          categories: chartsData.listYear,
        },
        yAxis: {
          title: '',
          stackLabels: {
            enabled: true,
            style: {
              color: 'red',
            },
          },
        },
        series: arr,
      };
      // 存入session给第四步用
      sessionStorage.setItem('histogram', JSON.stringify(this.option));
      this.highChartsShow = true;
    },
    getEduAnalyzeTableFn(parames) {
      this.$_post(this.$API.getEduAnalyzeTable, parames)
        .then((res) => {
          this.tableData = res.data.lists;
          this.cols = res.data.title;
          this.activeName = 'first';
          console.log('this.tableData===', this.tableData);
          console.log('this.cols===', this.cols);
        })
        .catch(error => console.log(error));
    },
    r(row, column, cellValue) {
      return this.moneyFilter(cellValue);
    },
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      if (`${x}`.indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 蒙特卡洛分析图数据组装方法
    monteCarloDataFn(res) {
      const arr = [];
      const yearsArr = res.list;
      if (res.info.ratio === 0) {
        arr.success = res.info.middleList;
        arr.middleList = res.info.success;
        arr.fail = res.info.fail;
      } else if (res.info.ratio === 0) {
        arr.success = res.info.success;
        arr.middleList = res.info.middleList;
        arr.fail = res.info.fail;
      } else {
        arr.success = res.info.success;
        arr.middleList = res.info.middleList;
        arr.fail = res.info.fail;
      }
      let colorLine = '';
      let colorLineTwo = '#FFA100';
      if (res.info.ratio !== 1 && res.info.ratio !== 0) {
        colorLine = '#FFA100';
        colorLineTwo = '#BAC6C8';
      } else if (res.info.ratio !== 0) {
        colorLine = '#02BB6F';
      } else if (res.info.ratio !== 1) {
        colorLine = '#FFA100';
        colorLineTwo = '#FFA100';
      }
      console.log(arr, yearsArr, '图表数据');
      const seriesArr = [
        {
          name: '成功',
          type: 'line',
          color: '#02BB6F',
          areaStyle: {
            normal: { origin: 'start', color: '#00CD87', opacity: 1 },
          },
          data: arr.success,
        },
        {
          name: res.info.ratio !== 1 ? '' : '失败',
          type: 'line',
          color: colorLineTwo,
          areaStyle: {
            normal: { origin: 'start', color: '#FFE2B2', opacity: 1 },
          },
          data: arr.middleList,
        },
        {
          name: res.info.ratio !== 1 ? '失败' : '',
          type: 'line',
          color: colorLine,
          areaStyle: {
            normal: { origin: 'start', color: '#fff', opacity: 1 },
          },
          data: arr.fail,
        },
      ];
      return {
        title: {
          text: '金额(元)',
          top: '5%',
          textStyle: {
            fontWeight: 400,
            fontSize: 14,
          },
        },
        // tooltip: {},
        legend: {
          selectedMode: false,
          data: ['成功', '失败'],
        },

        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: yearsArr,
            // 隐藏刻度
            axisTick: {
              show: false,
            },
            // 隐藏坐标轴
            axisLine: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              // formatter(value) { //竖文本
              //   return value.split('').join('\n');
              // },
            },
          },
        ],
        yAxis: [
          {
            offset: 1,
            type: 'value',
            splitLine: false,
          },
        ],
        series: seriesArr,
      };
    },
    // 仪表盘组装数据
    meterDataFn(res) {
      let msg = res.info.ratio * 100;
      msg = msg.toFixed(2);
      this.meterDataMsg = msg;
      const bar = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        series: [
          {
            name: '2019-02-12 任务分析',
            type: 'gauge',
            detail: { formatter: '{value}%' },
            axisLine: {
              show: true,
              lineStyle: {
                width: 30,
                shadowBlur: 0,
                color: [
                  [0.2, '#FF6A70'],
                  [0.8, '#FFA100'],
                  [1, '#00CD87'],
                ],
              },
            },
            data: [{ value: msg, name: '可行性' }],
          },
        ],
      };
      return bar;
    },
    getEduAnalyzeFeasibilityFn(num) {
      const parames = {
        data: {
          cis: this.cust.cis,
          status: num,
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          riskLevel: JSON.parse(sessionStorage.getItem('custInfo')).riskLevel.replace('C', ''),
        },
      };
      this.$_post(this.$API.getEduAnalyzeFeasibility, parames)
        .then((res) => {
          if (res.errorCode === 'E00000') {
            this.$store.commit('setChildStepStatys', false);
            // 判断是否需要测算可行性分析
            this.meterStatus = res.data.status;
            console.log(this.meterStatus, '************************************');
            // 仪表盘
            this.meterData = this.meterDataFn(res.data);
            this.meterDataShow = true;
            // 蒙特卡洛
            this.monteCarloData = this.monteCarloDataFn(res.data);
            this.monteCarloDataShow = true;
          } else {
            this.$store.commit('setChildStepStatys', true);
            this.$message.error(res.errorMsg);
          }
        })
        .catch(error => console.log(error));
    },
    getEduAnalyzeFeasibilityStatusFn(num) {
      const parames = {
        data: {
          cis: this.cust.cis,
          status: num,
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          riskLevel: JSON.parse(sessionStorage.getItem('custInfo')).riskLevel.replace('C', ''),
        },
      };
      this.$_post(this.$API.getEduAnalyzeFeasibility, parames).then((res) => {
        console.log(res, 'resssss');
        console.log(res.data.status, 'res.data.status');
        console.log(typeof res.data.status, 'res.data.status');
        this.meterStatus = res.data.status;
        if (this.meterStatus !== '1') {
          this.getEduAnalyzeFeasibilityFn(this.meterStatus);
        }
        if (res.data.status === '0') {
          this.$store.commit('setChildStepStatys', true);
        } else if (res.data.status === '1') {
          this.$store.commit('setChildStepStatys', false);
        } else if (res.data.status === '2') {
          this.$store.commit('setChildStepStatys', true);
        }
        if (res.data.status !== '1') {
          return;
        }
        this.meterData = this.meterDataFn(res.data);
        this.meterDataShow = true;
        // 蒙特卡洛
        this.monteCarloData = this.monteCarloDataFn(res.data);
        this.monteCarloDataShow = true;
      });
    },
    getMeasurePreviewFn(parames) {
      this.$_post(this.$API.getMeasurePreview, parames).then((res) => {
        console.log('red-------', res);
        this.textObj = res.data;
      });
    },
  },
};
</script>
<style lang="scss">
.analysis {
  .analysisOverview {
    background-color: #fff;
    .analysisOverview-title {
      padding: 15px 20px;
      border-bottom: 1px solid #eeeeee;
      h3 {
        font-size: 16px;
        font-weight: 400;
        color: rgba(48, 49, 51, 1);
        line-height: 24px;
      }
    }
    .analysisOverview-main {
      padding: 5px 20px 15px;
      .analysisOverview-main-top {
        ul {
          li {
            p {
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 1);
              line-height: 21px;
              span {
                color: #fa6b6b;
              }
            }
          }
        }
      }
      .analysisOverview-main-bottom {
        margin-top: 15px;
        ul {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: nowrap;
          li {
            width: 28%;
            height: 105px;
            padding: 7px 14px 0 34px;
            background: rgba(245, 247, 250, 1);
            border-radius: 2px;
            position: relative;
            p {
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 21px;
              .red {
                color: #fa6b6b;
              }
            }
            strong {
              width: 30px;
              height: 30px;
              background: rgba(75, 160, 255, 1);
              border-radius: 2px;
              font-size: 20px;
              font-weight: bold;
              text-align: center;
              color: rgba(255, 255, 255, 1);
              line-height: 30px;
              position: absolute;
              top: 8px;
              left: -5px;
            }
          }
        }
      }
    }
  }
  .analysisTabs {
    .el-tabs__nav-scroll {
      padding-left: 20px;
    }
    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
    .el-tabs__header {
      margin: 0 0 7px;
    }
    .analysisTabs-first {
      background-color: #fff;
      padding: 20px 40px 40px;
      h3 {
        font-size: 18px;
        font-weight: 400;
        color: rgba(48, 49, 51, 1);
        line-height: 27px;
      }
    }
    .analysisTabs-second {
      background-color: #fff;
      padding: 20px 20px 60px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap;
      .analysisTabs-second-left {
        width: 37%;
        border: 1px solid #eff1f7;
        padding: 12px 24px;
        .echarts {
          width: 470px;
          height: 450px;
        }
        p {
          font-size: 15px;
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          line-height: 21px;
          span {
            color: #fa7c7c;
          }
        }
      }
      .analysisTabs-second-right {
        padding: 0 20px;
        width: 55%;
        p {
          text-indent: 2em;
          font-size: 14px;
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          line-height: 21px;
          &:first-of-type {
            margin-top: 20px;
          }
        }
        .echarts {
          width: 600px;
          height: 280px;
        }
      }
    }
    .analysisTabs-second-false {
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      padding: 90px 0 130px;
      div {
        font-size: 14px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        line-height: 21px;
        margin-left: 60px;
        p {
          margin-bottom: 20px;
        }
        .el-button {
          padding: 12px 25px;
        }
      }
    }
  }
}
</style>
